// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/azubi-seminar-in-fuersteneck/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const azubiSeminarInFuersteneckDE: PageEntry = {
  id: "post.azubi-seminar-in-fuersteneck",
  locale: "de",
  slug: "azubi-seminar-in-fuersteneck",
  seo: {
    title: "Azubi-Seminar in Fürsteneck | Dietz GmbH",
    description: "Azubi-Seminar in Fürsteneck",
  },
  type: "post",
  h1: "Azubi-Seminar in Fürsteneck",
  blocks: [
    { kind: "heading", level: 2, text: "Azubi-Seminar in Fürsteneck" },
    { kind: "heading", level: 3, text: "Internes" },
    { kind: "paragraph", text: "Zum 5-tägigen Azubi-Seminar reisten Antonio Hanft, Florian Knoch, Dominik Siebert und Hamid Qayomi dieses Jahr vom 10–14.10.2016 nach Fürsteneck. Nachdem die Azubis in Gruppen aufgeteilt wurden, ging es in den Wald, wo für die erste Aufgabe Holz gesammelt wurde. Die Aufgabenstellung lautete, einen Stuhl zu entwerfen und aus dem gesammelten Holz zu bauen. Die so entstandenen Sitzmöbel wurden am Ende des Tages von den Meistern genau unter die Lupe genommen und getestet. Erfinderisch ging es auch am 2. und 3. Tag zu, die ganz im Zeichen der kreativen Werkstätten standen. Die Azubis arbeiteten in verschiedenen Gruppen Themenaufgaben aus. Für eine willkommene Pause vom handwerklichen Arbeiten sorgte ein Ausflug zur Gedenkstätte „Point Alpha“, wo sich eindrucksvolle historische Relikte aus der Zeit des Kalten Krieges besichtigen lassen. Zurück in Fürsteneck wurden dann am Abend des 4. und am Morgen des letzten Seminartags die kreativen Projektarbeiten vorgestellt: u.a. Alternative Energiequellen und E-Autos." }
  ],
};
